module.exports = __webpack_public_path__ + "img/N2F1_new.c7106874.jpg";